var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.appUpdated)?_c('b-alert',{staticClass:"m-0 border-radius-0",attrs:{"variant":"success","show":""}},[_vm._v("\n    New version was released. Please "),_c('a',{staticClass:"alert-link",attrs:{"href":"javascript:;"},on:{"click":_vm.reloadApp}},[_vm._v("click here")]),_vm._v(" to refresh the app and avoid any bugs.\n")]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efa473e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AutoReload.vue
// module id = null
// module chunks = 